import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MessService } from 'src/app/_services/mess-service.service';
import { PartnersService } from 'src/app/_services/partners.service';

@Component({
  selector: 'app-partners-add',
  templateUrl: './partners-add.component.html',
})
export class PartnersAddComponent implements OnInit, OnDestroy {
  addPartnerForm: FormGroup;

  isFromAddPage: boolean = false;
  previousUrl;

  subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private messService: MessService,
    private router: Router,
    private route: ActivatedRoute,
    private partnersService: PartnersService
  ) {}

  // * Lifecycles === //
  ngOnInit(): void {
    // * Create from
    this.addPartnerForm = this.fb.group({
      code: ['', Validators.required],
      company: ['', Validators.required],
      contact: ['', Validators.required],
      address: ['', Validators.required],
      email: ['', Validators.required],
      phone: ['', Validators.required],
      note: [''],
    });

    // * Check if user come from some ADD page (NIP)
    this.subscriptions.push(
      this.route.queryParams.subscribe((params) => {
        // Defaults to 0 if no query param provided.
        this.previousUrl = params['fromPage'] || 0;
        this.isFromAddPage = this.previousUrl != 0 ? true : false;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.messService.clearErrors();
  }

  // * Add partner
  onAddPartner() {
    const partner = this.addPartnerForm.getRawValue();
    this.subscriptions.push(
      this.partnersService.addPartner(partner).subscribe(
        () => {
          this.messService.add({
            severity: 'success',
            title: 'Uspešno kreiranje',
            detail: 'Kreirali ste novog partnera.',
          });
          if (this.isFromAddPage) {
            // Ako je korisnik dodao partnera vraca ga na NIP formu ali mu dodaje i parametra addedPartner kako bi mogao da nadje kog partnera je korisnik dodao
            this.router.navigate([this.previousUrl], {
              relativeTo: this.route,
              queryParams: {
                fromPage: '/partners',
                addedPartner: this.addPartnerForm.get('company').value,
              },
            });
          } else {
            this.router.navigate(['./../'], { relativeTo: this.route });
          }
        },
        (error) => {
          const errorObj = error.error.errors;
          const form = this.addPartnerForm;
          const messService = this.messService;
          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });
        }
      )
    );
  }

  // * Helpers === //
}
